import React from 'react';
import { FallbackProps, useErrorBoundary } from 'react-error-boundary';

export default function ErrorBoundaryFallback({ error }: FallbackProps) {
  const { resetBoundary } = useErrorBoundary();

  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: 'red' }}>{error.message}</pre>
      <button type="button" onClick={resetBoundary}>Try again</button>
    </div>
  );
}
